import { render } from "./MarketingEventPropsCmp.vue?vue&type=template&id=a93a7fa4"
import script from "./MarketingEventPropsCmp.vue?vue&type=script&lang=js"
export * from "./MarketingEventPropsCmp.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__